module.exports = __webpack_public_path__ + "static/media/x-circle.131502e4.svg";